import { render, staticRenderFns } from "./FemaleBody.vue?vue&type=template&id=637ba812&"
import script from "./FemaleBody.vue?vue&type=script&lang=js&"
export * from "./FemaleBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports